// extracted by mini-css-extract-plugin
export var actions = "_1b-0";
export var actionsContainer = "_1b-6";
export var border = "_1b-1";
export var childFullHeight = "_1b-d";
export var collapse = "_1b-2";
export var content = "_1b-8";
export var contentChild = "_1b-c";
export var fullscreen = "_1b-a";
export var headerContainer = "_1b-3";
export var headerRow = "_1b-5";
export var hidePadding = "_1b-9";
export var noScrollX = "_1b-e";
export var noScrollY = "_1b-f";
export var optOutTopPadding = "_1b-b";
export var pagePadding = "_1b-7";
export var profile = "_1b-g";
export var profileContainer = "_1b-h";
export var profileImage = "_1b-i";
export var profileMain = "_1b-j";
export var profileSubtitle = "_1b-l";
export var profileTitle = "_1b-k";
export var tabsWrapper = "_1b-4";
export var title = "_1b-m";